<template>
    <div>
        <div class="wrapper-all">
            <div class="wrapper">
                <div>
                    <h4>
                    Coming Soon
                </h4>
                    

                    <div class="row">
                        <div class="col-12">
                            <div class="row justify-content-center">
                                <base-button
                                    btn-type="submit"
                                    btn-variant="primary"
                                    btn-label="CONTINUE"
                                    :class="loading ? 'disabled' : ''"
                                    :disabled="loading"
                                    @onClickButton="onClick"
                                >
                                </base-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import request from '@/utils/request'
import Radio from '@/components/registration/Radio.vue'
import PopupButton from '@/components/registration/PopupButton.vue'
import { mapGetters } from 'vuex'

export default {
    components: {
        PopupButton,
        Radio,
    },

    props: {
        data: { type: String },
    },

    data() {
        return {
            languageOption: null,
            options: [
                {
                    text: 'English',
                    value: 'en',
                },
                {
                    text: 'Urdu',
                    value: 'urd',
                },
            ],
        }
    },
    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        // ...mapState({
        //     userOcr: (state) => state.registration.useOcr,
        // }),

        ...mapGetters(['dataSegmentId', 'loading', 'form']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    },
    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */

    mounted() {},
    methods: {
        onClick() {
            this.$emit('agreed')
        },
      
    },
}
</script>
<style scoped>
p {
    margin: 0;
    font-size: 16px;
    padding: 0px 20px;
}
.icon-tick-with-circle {
    color: green;
    font-size: 30px;
    cursor: pointer;
}
h4 {
    margin-bottom: 25px;
    text-align: center;
    
    font-family: 'ProximanovaSemibold';
}
</style>
